import * as TypeGraphQL from "type-graphql";
export var TradeSignal;
(function (TradeSignal) {
    TradeSignal["GOLDEN_CROSS"] = "GOLDEN_CROSS";
    TradeSignal["DEATH_CROSS"] = "DEATH_CROSS";
    TradeSignal["MOVING_AVERAGE_CROSSOVER"] = "MOVING_AVERAGE_CROSSOVER";
    TradeSignal["RSI_OVERBOUGHT"] = "RSI_OVERBOUGHT";
    TradeSignal["RSI_OVERSOLD"] = "RSI_OVERSOLD";
    TradeSignal["MACD_CROSSOVER"] = "MACD_CROSSOVER";
    TradeSignal["BOLLINGER_BANDS_BREAKOUT"] = "BOLLINGER_BANDS_BREAKOUT";
    TradeSignal["TREND_REVERSAL"] = "TREND_REVERSAL";
    TradeSignal["PRICE_ACTION"] = "PRICE_ACTION";
    TradeSignal["IMPLIED_VOLATILITY_SURGE"] = "IMPLIED_VOLATILITY_SURGE";
    TradeSignal["BREAKOUT_ABOVE_RESISTANCE"] = "BREAKOUT_ABOVE_RESISTANCE";
    TradeSignal["BREAKDOWN_BELOW_SUPPORT"] = "BREAKDOWN_BELOW_SUPPORT";
    TradeSignal["SUPPORT_LEVEL_HOLD"] = "SUPPORT_LEVEL_HOLD";
    TradeSignal["RESISTANCE_LEVEL_HOLD"] = "RESISTANCE_LEVEL_HOLD";
    TradeSignal["FIBONACCI_RETRACEMENT"] = "FIBONACCI_RETRACEMENT";
    TradeSignal["STOCHASTIC_OVERSOLD"] = "STOCHASTIC_OVERSOLD";
    TradeSignal["STOCHASTIC_OVERBOUGHT"] = "STOCHASTIC_OVERBOUGHT";
    TradeSignal["PIVOT_POINT"] = "PIVOT_POINT";
    TradeSignal["VOLUME_SURGE"] = "VOLUME_SURGE";
    TradeSignal["MEAN_REVERSION_LEVEL"] = "MEAN_REVERSION_LEVEL";
    TradeSignal["NEWS_SENTIMENT_CHANGE"] = "NEWS_SENTIMENT_CHANGE";
    TradeSignal["SENTIMENT_ANALYSIS_TRIGGER"] = "SENTIMENT_ANALYSIS_TRIGGER";
    TradeSignal["GAP_AND_GO_LONG"] = "GAP_AND_GO_LONG";
    TradeSignal["GAP_AND_GO_SHORT"] = "GAP_AND_GO_SHORT";
    TradeSignal["GAP_FADE_LONG"] = "GAP_FADE_LONG";
    TradeSignal["GAP_FADE_SHORT"] = "GAP_FADE_SHORT";
    TradeSignal["ORB_BREAKOUT"] = "ORB_BREAKOUT";
    TradeSignal["ORB_BREAKDOWN"] = "ORB_BREAKDOWN";
    TradeSignal["VWAP_BOUNCE"] = "VWAP_BOUNCE";
    TradeSignal["VWAP_REJECTION"] = "VWAP_REJECTION";
    TradeSignal["NO_EARLY_SIGNAL"] = "NO_EARLY_SIGNAL";
    TradeSignal["NO_SIGNAL"] = "NO_SIGNAL";
})(TradeSignal || (TradeSignal = {}));
TypeGraphQL.registerEnumType(TradeSignal, {
    name: "TradeSignal",
    description: undefined,
});
//# sourceMappingURL=TradeSignal.js.map